/*
 *  Layout.
 */

export default {
    responsive: {
        desktop: `@media (min-width: 770px)`,
        device: `@media (min-width: 320px) and (max-width: 769px)`,
        portrait: `@media (max-width: 1080px)`,
        sff: `@media (max-width: 479px)`
    },
    gutter: `0.66rem`
};
